import { API_BASE_URL } from '../config/apiConfig';

/**
 * Generate a print-ready PDF from image URLs
 * @param {Object} params - { imageUrls: string[], bookId?: string }
 * @param {Object} options - { maxRetries: number, retryDelay: number }
 * @returns {Promise<Blob>} PDF file as Blob
 */
export const generatePDFs = async (params) => {
  const token = localStorage.getItem("auth_token");
  const response = await fetch(`${API_BASE_URL}print/generate-pdf`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Failed to generate PDF (${response.status}): ${errorText}`);
  }

  const reader = response.body.getReader();
  const contentLength = +response.headers.get("Content-Length") || 0;
  let receivedLength = 0;
  const chunks = [];

  console.log("📡 Receiving PDF stream...");

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value);
    receivedLength += value.length;
    if (contentLength) {
      const percent = ((receivedLength / contentLength) * 100).toFixed(2);
      console.log(`📈 Downloaded ${percent}%`);
    } else {
      console.log(`📦 Received ${receivedLength} bytes`);
    }
  }

  const pdfBlob = new Blob(chunks, { type: "application/pdf" });
  if (!pdfBlob.size) throw new Error("Received empty PDF file");

  console.log("✅ PDF fully assembled from chunks:", pdfBlob);
  return pdfBlob;
};

/**
 * Download PDF blob as a file
 * @param {Blob} pdfBlob - PDF blob
 * @param {string} filename - Desired filename
 */
export const downloadPDF = (pdfBlob, filename = 'book.pdf') => {
  const url = URL.createObjectURL(pdfBlob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

/**
 * Open PDF in a new browser tab
 * @param {Blob} pdfBlob - PDF blob
 */
export const openPDFInNewTab = (pdfBlob) => {
  const url = URL.createObjectURL(pdfBlob);
  window.open(url, '_blank');
};
